import React, { ReactNode } from "react";
import styles from "./center-center-container.module.scss";

interface CenterCenterContainerPropTypes {
  children: ReactNode;
}

const cssClassName = "center-center-container";

export const CenterCenterContainer = ({
  children,
}: CenterCenterContainerPropTypes) => {
  return <div className={styles[cssClassName]}>{children}</div>;
};
